// components/validations.ts
import * as yup from 'yup';

const optionSchema = yup.object().shape({
  label: yup.string().required('Option label is required'),
  value: yup.mixed().required('Option value is required'),
});

export const formFieldValidation = yup.object().shape({
  label: yup.string().required('Label is required'),
  fieldId: yup.string().required('Field ID is required'),
  type: yup.string().oneOf([
    'text', 'number', 'boolean', 'select', 'radio', 'checkbox', 'date'
  ], 'Invalid field type').required('Field type is required'),
  placeholder: yup.string(),
  helpText: yup.string(),
  required: yup.boolean().default(false),
  order: yup.number().min(0, 'Order must be positive').optional(),
  options: yup.array().of(optionSchema).when('type', {
    is: (type: string) => ['select', 'radio', 'checkbox'].includes(type),
    then: (schema) => schema.min(1, 'At least one option is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  errorMessage: yup.string().when('required', {
    is: true,
    then: (schema) => schema.required('Error message is required when field is required'),
    otherwise: (schema) => schema.optional(),
  }),
 
});



export const subAdminSchema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup.string().email().required("Email is required"),
  phone: yup.string().nullable(),


  rights: yup.array().of(yup.string()).optional(),
  status: yup.boolean().default(true),
});